// import images
import { NavLink } from "react-router-dom";
import shopMin from "../assets/image/shop-min.jpg";
import shopWebp from "../assets/image/shop.webp";
// import css
import Classes from "./style/Lonading.module.css";

export default function HeroSection() {
  return (
    <section className={`${Classes.section} ${Classes.sectionHero}`}>
      <div
        className={`${Classes.container} ${Classes.grid} ${Classes.gridTwoColum}`}
      >
        <div className={Classes.sectionHeroData}>
          <p className={`${Classes.heroTopData} `}>My shop</p>
          <h1 className={Classes.heroHeading} id="Mahapravu_Furniture">
            Mahapravu Furniture
          </h1>
          <p className={Classes.heroPara}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam,
            tenetur. Harum, nam cupiditate, necessitatibus quasi possimus non,
            maxime vitae expedita tenetur ullam quos libero dignissimos atque
            ea? A, labore ut!
          </p>
          <NavLink to="#Mahapravu_Furniture"  className={`${Classes.btnL}`}>
            Here me
          </NavLink>
        </div>
        <div>
          <div className={Classes.heroSectionImg}>
            <picture>
              <source srcSet={shopWebp} type="image/webp" />
              <source srcSet={shopMin} type="image/jpg" />
              <img
                loading="lazy"
                className={Classes.heroImg}
                src={shopMin}
                alt="open_img"
              />
            </picture>
          </div>
        </div>
      </div>
    </section>
  );
}
